import React from 'react'
import { Logo, Container, Row } from 'react-angle-dashboard-components'
import { Layout } from '../../layout'
import { LogoWrapper } from '../style'

export const LoginLayout: React.FC = ({ children }) => {
  return (
    <Layout showUserDropdown={false} hideBarItems>
      <Container
        fluid
        className="px-0 vh-100 m-auto d-flex flex-column justify-content-center align-items-center"
      >
        <Row className="mr-auto ml-auto mb-6">
          <LogoWrapper>
            <Logo variant="full" color="primary" subTitleColor="dark" />
          </LogoWrapper>
        </Row>
        {children}
      </Container>
    </Layout>
  )
}
